/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../../styles/variables';
import AccessibleSVG, { SVGProps } from '../../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const FilePhotoshop32 = (props: SVGProps) => (
    <AccessibleSVG width={32} height={32} viewBox="0 0 32 32" {...props}>
        <g fill="none" fillRule="evenodd">
            <path
                fill="#051E25"
                fillRule="nonzero"
                d="M9 3h9.586a1 1 0 01.707.293l6.415 6.414a1 1 0 01.293.707V26A3 3 0 0123 29H9a3 3 0 01-3-3V6a3 3 0 013-3z"
            />
            <path
                fill={vars.white}
                fillOpacity={0.5}
                fillRule="nonzero"
                d="M19.286 3.286l5.01 5.009 1.412 1.412a1 1 0 01.203.293H21a2 2 0 01-2-2V3.09a1 1 0 01.286.196z"
            />
            <path
                fill="#26C9FF"
                d="M19.527 15.491c.79 0 1.34.116 1.643.25.074.045.092.116.092.179v1.223c0 .071-.046.116-.138.09-.403-.25-1-.403-1.597-.403-.725 0-.973.358-.973.652 0 .322.166.545 1.139 1.036 1.44.678 1.89 1.33 1.89 2.286 0 1.428-1.12 2.196-2.634 2.196-.798 0-1.487-.16-1.881-.384-.065-.027-.074-.071-.074-.143v-1.312c0-.09.046-.116.11-.072.579.366 1.24.527 1.845.527.725 0 1.028-.295 1.028-.696 0-.322-.211-.607-1.138-1.072-1.303-.607-1.845-1.223-1.845-2.25 0-1.152.927-2.107 2.533-2.107zM12.57 13c2.542 0 3.534 1.357 3.534 3.09 0 2.267-1.69 3.24-3.763 3.24-.35 0-.469-.017-.716-.017v3.428c0 .071-.028.107-.11.107H10.11c-.073 0-.11-.027-.11-.107v-9.59c0-.062.129-.106.202-.106.587-.027 1.46-.045 2.368-.045zm-.055 1.42c-.367 0-.716.018-.881.026v3.447c.21.018.376.018.743.018 1.074 0 2.084-.366 2.084-1.786 0-1.134-.725-1.705-1.946-1.705z"
            />
        </g>
    </AccessibleSVG>
);

export default FilePhotoshop32;
